<template lang="pug">
div
  .md-headline Properties
  md-layout(v-if='showMarketplaceSwitch')
    md-switch.md-primary(:disabled='!(entity.status === "public" || $get(this, "entity.publicationDate.date") )' , v-model='entity.includeInMarketplace', ) Include this content in the Rhebus TV Marketplace
  md-layout
    genre-selector#categories-dropdown.fixSize(v-model='entity.categories', :multiple='true', :show-required-error='formSubmitted && validations.categories.$invalid')
</template>

<script>
import GenreSelector from '../../shared-components/genre/GenreSelector';

export default {
  components: {
    GenreSelector
  },
  props: {
    showMarketplaceSwitch: {
      type: Boolean,
      default: true
    },
    entity: {
      type: Object,
      required: true
    },
    formSubmitted: {
      type: Boolean,
      required: true
    },
    validations: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.md-headline {
  margin-bottom: 15px;
}

.fixSize {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/PropertiesForm.vue